// Compression réelle côté client avant envoi — aucune photo n'était jamais redimensionnée
// (appareil photo moderne = 3 à 12 Mo par photo en pleine résolution), envoyée ET stockée
// telle quelle, puis redécodée en pleine résolution partout où elle est réaffichée dans
// une liste (Réclamations, HACCP, Artikelfinder...). Suspecté contribuer, avec le
// chargement à la demande des bibliothèques de scan (voir barcodeDecode.js), à la
// pression mémoire qui fait planter la PWA installée sur iOS (retour utilisateur
// 2026-07-31, confirmé "quasi inexistant mais existant" sur un appareil plus récent —
// cohérent avec un problème de mémoire cumulative, pas un bug isolé à un écran).
// Redimensionne au format JPEG, cap 1600px de côté (même valeur que
// PHOTO_DECODE_MAX_SIDE dans barcodeDecode.js), qualité 0.82 — largement suffisant pour
// toute preuve visuelle (réclamation, anomalie HACCP, fiche article), jamais un original
// à conserver pixel-perfect.
const MAX_SIDE = 1600;
const JPEG_QUALITY = 0.82;

export async function compressImageFile(file) {
  if (!file || !file.type || !file.type.startsWith("image/") || file.type === "image/svg+xml") return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const w = Math.max(1, Math.round(bitmap.width * scale));
    const h = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY));
    if (!blob || blob.size >= file.size) return file;
    const newName = file.name.replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], newName, { type: "image/jpeg", lastModified: Date.now() });
  } catch {
    return file;
  }
}

export function compressImageFiles(fileList) {
  return Promise.all(Array.from(fileList || []).map(compressImageFile));
}
